import domReady from '@wordpress/dom-ready';

export default class SidebarController {
  init () {
    domReady( function () {
      var menuItems = document.querySelectorAll( '.sidebar .menu-item-has-children' );
      var buttons = document.querySelectorAll( '.sidebar .menu-item-has-children button' );

      menuItems.forEach( ( menuItem ) => {
        menuItem.classList.forEach( ( className ) => {

					if ( className.startsWith( 'current-' ) ) {
            const parent = menuItem.closest( '.menu-item-has-children' )

            parent.querySelector( 'a' ).setAttribute( 'aria-expanded', 'true' );
            parent.querySelector( 'button' ).setAttribute( 'aria-expanded', 'true' );
            parent.querySelector( '.sub-menu' ).setAttribute( 'aria-expanded', 'true' );
          }
        } )
      } )

      buttons.forEach( ( item ) => {
        item.addEventListener( 'click', function ( e ) {
          var parent = e.target.parentNode; // grab parent <li> element

          if ( parent.classList.contains( 'open' ) ) {
            parent.classList.remove( 'open' )
            e.target.setAttribute( 'aria-expanded', 'false' );
            parent.querySelector( 'a' ).setAttribute( 'aria-expanded', 'false' );
            parent.querySelector( '.sub-menu' ).setAttribute( 'aria-expanded', 'false' );
          } else {
            parent.classList.add( 'open' );
            parent.querySelector( 'a' ).setAttribute( 'aria-expanded', 'true' );
            e.target.setAttribute( 'aria-expanded', 'true' );
            parent.querySelector( '.sub-menu' ).setAttribute( 'aria-expanded', 'true' );
          }
        } );
      } );
    } );
  }
}
